import { Link } from "react-router-dom";
import { ArrowIcon } from "../../Components/Brand/Icons";
import StationTrack from "../../Components/Track/StationTrack";
import { TECH_PRINCIPLES } from "../../content/tech";
import Seo from "../../seo/Seo";
import { breadcrumbSchema } from "../../seo/site";
import TechLoop from "./TechLoop";
import "./technologies.css";

const TechnologiesPage = () => (
  <>
    <Seo
      path="/technologies"
      title="Technologies We Use — React, Node.js, Flutter, AWS | Infinitude Stack"
      description="React, Angular, Vue, Node.js, Python, Java, React Native, Flutter, AWS, Google Cloud, Azure and more — the stack we use to build and ship your product."
      schema={[breadcrumbSchema("Technologies", "/technologies")]}
    />

    <div className="is-tech">
      {/* ---------- Hero ---------- */}
      <section className="is-container is-tech-hero">
        <div className="is-tech-hero__copy">
          <h1 className="is-display is-tech-hero__title">
            Modern tools, <strong className="is-accent-text">chosen for the job.</strong>
          </h1>
          <p className="is-lede is-tech-hero__lede">
            We work across the modern web, mobile and cloud stack — and recommend what
            fits your product, team and budget, not what’s fashionable.
          </p>
        </div>
      </section>

      {/* ---------- Every tool around the loop ---------- */}
      <TechLoop />

      {/* ---------- How we pick a stack ---------- */}
      <section className="is-tech-principles" aria-labelledby="tech-principles-title">
        <div className="is-container">
          <div className="is-section-head is-section-head--dark is-reveal">
            <div>
              <p className="is-eyebrow">How we choose</p>
              <h2 id="tech-principles-title" className="is-display is-h2">
                The right tool, <strong>for the right reason.</strong>
              </h2>
            </div>
          </div>
          <StationTrack items={TECH_PRINCIPLES} tone="dark" />
        </div>
      </section>

      {/* ---------- Not seeing your stack? ---------- */}
      <section className="is-container is-tech-ask">
        <Link to="/contact" className="is-scope-bar">
          <span className="is-scope-bar__text">
            Not seeing your stack? <span>Tell us what you run on.</span>
          </span>
          <span className="is-scope-bar__cta">Ask us →</span>
        </Link>
      </section>

      {/* ---------- CTA: rounded navy panel ---------- */}
      <section className="is-tech-cta" aria-labelledby="tech-cta-title">
        <div className="is-tech-cta__panel is-reveal">
          <h2 id="tech-cta-title" className="is-display is-tech-cta__title">
            The right stack <strong>for your idea.</strong>
          </h2>
          <Link to="/contact" className="is-btn is-btn--accent">
            Talk to an engineer
            <span className="is-btn__arrow">
              <ArrowIcon />
            </span>
          </Link>
        </div>
      </section>
    </div>
  </>
);

export default TechnologiesPage;
